import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createRejectedReportSlice = (set, get) => ({
    rejected: {
        loading: false,
        data: [],
        filtered: []
    },
    getRejectedInfo: async (params = {}) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ rejected: { ...state.rejected, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/business-Rejected-report",
                headers: { token },
                data: params
            });
            set(state => ({ rejected: { loading: false, data: resp.data, filtered: resp.data } }));
        } catch (error) {
            set(state => ({ rejected: { ...state.rejected, loading: false, data: [] } }));
        }
    }
});
